import React, { useState } from 'react';

import { useTranslate, useValidation } from '../../../../../../../hooks';

//import { addEmployeeType } from '../validations';
import { Button, TextInput } from '../../../../../../../components';
import { LoadingButton } from '../../../../../../../components/buttons';
import CloseIcon from '@mui/icons-material/Close';

function EditLocalizationStatus({
  toggleModal,
  customHandler,
  seletedData,
  isEditing,
}) {
  const { translate } = useTranslate();
  const [form, setForm] = useState({
    name: seletedData?.local_status_name,
    isDisabledGratuity: seletedData?.is_disabled_gratuity,
  });

  /* const { errors, validate } = useValidation(addEmployeeType, {
    name: form?.name,
  }); */

  const handleSaveEdit = async (e) => {
    /* e.preventDefault();
    if (await validate()) {
      customHandler(form);
    } */
  };

  const handleChange = ({ key, value }) => {
    setForm((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  return (
    <>
      {/* <div className="w-[450px] h-[250px] p-5 bg-white rounded-md app-modal base-modal">
      <span className="flex items-center gap-x-2 mb-5 h-[26px]">
        <span className="flex gap-x-1">
          <p className="welcome-text font-bold">{translate('Edit')}</p>
          <p className="welcome-text2 font-bold">
            {translate('Employee Type')}
          </p>
        </span>
        <div className="ml-auto cursor-pointer" onClick={toggleModal}>
          <CloseIcon className="text-gray-400" />
        </div>
      </span>
      <form
        onSubmit={handleSaveEdit}
        className="flex flex-col gap-4 h-[164px] w-[100%]"
      >
        <TextInput
          fullWidth
          label={translate('Employee Type Title')}
          error={errors?.name}
          helperText={errors?.name}
          defaultValue={form?.name}
          onChange={(e) => {
            handleChange({
              key: `name`,
              value: e?.target?.value,
            });
          }}
        />
        <div className="flex justify-end gap-4 mt-auto">
          <Button
            className={`outline-btn min-w-[75px] rounded-md`}
            onClick={toggleModal}
          >
            {translate('Cancel')}
          </Button>
          <LoadingButton
            className="primary-btn min-w-[75px] rounded-md"
            type="submit"
            isLoading={isEditing}
          >
            {translate('Save')}
          </LoadingButton>
        </div>
      </form>
    </div> */}
    </>
  );
}

export default EditLocalizationStatus;
